import * as React from 'react';

import {Button} from 'shells/button/button';
import {SaveButton} from 'shells/button/save-button/save-button';
import {Illustration} from 'shells/illustrations/illustration';
import {StackLegacy} from 'shells/layout/stack/stack-legacy';
import {FooterBar} from 'shells/modal/footer-bar';
import {MarketingBody} from 'shells/typography/marketing-body';
import {MarketingHeader} from 'shells/typography/marketing-header';

import type {
    DripSequenceFragment as DripSequence,
    SmsDripSequenceFragment as SmsDripSequence,
} from 'nutshell-graphql-types';

import {GoalCard} from '../../goal/goal-card';
import {StartTriggerCard} from '../../start-trigger/start-trigger-card';

import styles from './prepare-to-activate.module.css';

type Props = {
    dripSequence: DripSequence | SmsDripSequence;
    onClickPrimary: (dripSequenceId: string) => Promise<any>;
    onClickSecondary: () => any;
};

export function PrepareToActivate(props: Props) {
    const [isActivating, setIsActivating] = React.useState<boolean>(false);

    const {startTrigger, goal} = props.dripSequence;

    return (
        <>
            <div className={styles['prepare-to-activate-container']}>
                <MarketingHeader>
                    You’re ready to activate{' '}
                    <span className={styles['drip-sequence-name']}>{props.dripSequence.name}</span>
                </MarketingHeader>
                <div className={styles['content-container']}>
                    <div className={styles['left-container']}>
                        {props.dripSequence.__typename === 'Campaign' ? (
                            <Illustration src='parachuting-envelopes' />
                        ) : (
                            <Illustration src='activate-sms-drip-sequence' width={294} />
                        )}
                    </div>
                    <div className={styles['right-container']}>
                        <MarketingBody>
                            This drip sequence contains{' '}
                            <b>{getEditionsCountText(props.dripSequence.editions.totalCount)}</b>.
                        </MarketingBody>
                        <StackLegacy spacing={16}>
                            <StartTriggerCard
                                startTrigger={startTrigger}
                                isLoading={false}
                                shouldShowEmptyState={Boolean(!startTrigger)}
                                isActive={
                                    props.dripSequence.status !== 'CANCELLED' &&
                                    props.dripSequence.status !== 'RETIRED'
                                }
                            />

                            {goal ? <GoalCard isLoading={false} goal={goal} /> : undefined}
                        </StackLegacy>
                    </div>
                </div>
            </div>
            <FooterBar
                left={
                    <Button variant='text' size='big' onClick={props.onClickSecondary}>
                        Back
                    </Button>
                }
                right={
                    <SaveButton
                        buttonText='Activate sequence'
                        savingText='Activating…'
                        isSaving={isActivating}
                        // @ts-expect-error
                        onClick={() => {
                            setIsActivating(true);

                            props.onClickPrimary(props.dripSequence.id);
                        }}
                    />
                }
            />
        </>
    );
}

function getEditionsCountText(count: number): string {
    if (count === 1) {
        return 'one message';
    }

    return `${count} messages`;
}
